<template>
  <div :class="['tasks']">
    <div v-if="istoggle" class="toggle_accordion" @click="accordion()">
      <span class="toggleName">{{getToggleName()}}</span>
      <i :class="['icon_toggle', 'fa', 'fa-angle-up', {'rotate180': !taskGroupOpen}]"></i>
    </div>
    <div v-show="taskGroupOpen" v-for="(taskElement, index) in definition.task" :key="index" :class="[taskElement.taskId, taskElement.type.id]">
      <definition-task-file v-if="taskElement.type.id === 'file'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition"
      />
      <definition-task-button v-else-if="taskElement.type.id === 'button'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition" @refreshDefinitionContent="refreshDefinitionContent"
      />
      <definition-task-definition v-else-if="taskElement.type.id === 'definition'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :embeddedDefinition="embeddedDefinition" :builderModifyCall="builderModifyCall" :builderDeleteCall="builderDeleteCall"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex"
        @definitionloaded="definitionloaded" @definitionsaved="definitionsaved" @definitionupdated="definitionupdated" @definitiondeleted="definitiondeleted" @definitionerror="definitionerror" @validatingFormError="validatingFormError"
        @popupClose="popupClose" @refreshDefinitionContent="refreshDefinitionContent"
      />
      <definition-task-eval v-else-if="taskElement.type.id === 'eval' || taskElement.type.id === 'evalOnChange'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :newEval="popupClosed" :language="language" :authorization="authorization" :type="type"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition"
      />
      <definition-task-searcher v-else-if="taskElement.type.id === 'searcher'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :istoggle="istoggle"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinitionContent="refreshDefinitionContent"
      />
      <definition-task-refresh v-else-if="taskElement.type.id === 'refresh'"
        :refresh="popupClosed"
        @refreshDefinitionContent="refreshDefinitionContent"
      />
      <definition-task-download v-else-if="taskElement.type.id === 'download'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition"
      />
      <definition-task-link v-else-if="taskElement.type.id === 'link'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :language="language" :authorization="authorization" :type="type" :repeatableItemIndex="repeatableItemIndex" :calledTaskIndex="calledTaskIndex"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)"
        @refreshDefinition="refreshDefinition" @taskLink="taskLink"
      />
      <definition-task-waiting-process v-else-if="taskElement.type.id === 'waitingProcess'"
        :task="taskElement" :definition="definition" :object="getScopeObject(taskElement)" :taskRefresh="taskRefresh" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected"
        :newEval="popupClosed" :language="language" :authorization="authorization" :type="type"
        :class="getRepeatableGroupTaskClass(taskElement.taskId)" :editRepeatableWaitProcess="editRepeatableWaitProcess"
        @refreshDefinition="refreshDefinition" @waitingProcessFinished="waitingProcessFinished" @waitingProcessInit="waitingProcessInit"
      />
    </div>
  </div>
</template>

<script>
import DefinitionTaskFile from './taskFile'
import DefinitionTaskButton from './taskButton'
import DefinitionTaskDefinition from './taskDefinition'
import DefinitionTaskEval from './taskEval'
import DefinitionTaskSearcher from './taskSearcher'
import DefinitionTaskRefresh from './taskRefresh'
import DefinitionTaskDownload from './taskDownload'
import DefinitionTaskLink from './taskLink'
import DefinitionTaskWaitingProcess from './taskWaitingProcess'
import moment from 'moment'

export default {
  name: 'definition-task',
  props: [
    'definition',
    'object',
    'definitionObject',
    'taskRefresh',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'location',
    'repeatableGroupPresentation',
    'embeddedDefinition',
    'builderModifyCall',
    'builderDeleteCall',
    'repeatableItemIndex',
    'calledTaskIndex',
    'editRepeatableWaitProcess',
    'istoggle'
  ],
  components: {
    DefinitionTaskFile,
    DefinitionTaskButton,
    DefinitionTaskDefinition,
    DefinitionTaskSearcher,
    DefinitionTaskEval,
    DefinitionTaskRefresh,
    DefinitionTaskDownload,
    DefinitionTaskLink,
    DefinitionTaskWaitingProcess
  },
  data () {
    return {
      task: null,
      popupClosed: null,
      taskGroupOpen: true
    }
  },
  beforeMount () {
    if (this.definition.task) {
      for (var i = 0; i < this.definition.task.length; i++) {
        var task = this.definition.task[i]

        if (task.visual) {
          var visualFound = false
          for (var j = 0; j < this.visuals.length; j++) {
            var visual = this.visuals[j]

            if (visual.id === task.id) {
              visualFound = true
            }
          }

          if (!visualFound) {
            this.visuals.push(JSON.parse(task.visual.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ')))
          }
        }
      }
    }
    if (this.istoggle) {
      this.taskGroupOpen = false
    }
  },
  methods: {
    refreshDefinition (object, scope) {
      this.$emit('refreshDefinition', object, scope)
    },
    popupClose () {
      this.popupClosed = moment().valueOf()
    },
    getRepeatableGroupTaskClass (taskId) {
      var result = ''
      if (!this.location || this.location === 'edit') {
        result = this.getRepeatableGroupEditTaskClass(taskId)
      } else if (this.location === 'presentation') {
        result = this.getRepeatableGroupPresentationTaskClass(taskId)
      }
      return result
    },
    getRepeatableGroupEditTaskClass (taskId) {
      var result = ''
      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.tasks && this.repeatableGroupPresentation.tasks.editMode) {
        var found = false
        for (var i = 0; i < this.repeatableGroupPresentation.tasks.editMode.length && !found; i++) {
          var task = this.repeatableGroupPresentation.tasks.editMode[i]
          if (task.taskId === taskId) {
            result = task.class
            found = true
          }
        }
      }
      return result
    },
    getRepeatableGroupPresentationTaskClass (taskId) {
      var result = ''
      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.tasks && this.repeatableGroupPresentation.tasks.presentationMode) {
        var found = false
        for (var i = 0; i < this.repeatableGroupPresentation.tasks.presentationMode.length && !found; i++) {
          var task = this.repeatableGroupPresentation.tasks.presentationMode[i]
          if (task.taskId === taskId) {
            result = task.class
            found = true
          }
        }
      }
      return result
    },
    definitionloaded (content) {
      this.$emit('definitionloaded', content)
    },
    definitionsaved (object, response) {
      this.$emit('definitionsaved', object, response)
    },
    definitionupdated (object, response) {
      this.$emit('definitionupdated', object, response)
    },
    definitiondeleted (object, response) {
      this.$emit('definitiondeleted', object, response)
    },
    definitionerror (error, resultError, container) {
      this.$emit('definitionerror', error, resultError, container)
    },
    validatingFormError () {
      this.$emit('validatingFormError')
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    getScopeObject (task) {
      var result
      if (task && task.scope && task.scope === 'full' && this.definitionObject) {
        result = this.definitionObject
      } else {
        result = [this.object]
      }
      return result
    },
    waitingProcessFinished (result, code) {
      this.$emit('waitingProcessFinished', result, code)
    },
    waitingProcessInit () {
      this.$emit('waitingProcessInit')
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    accordion () {
      this.taskGroupOpen = !this.taskGroupOpen
    },
    getToggleName () {
      var result = ''
      if (this.definition.task.length === 1) {
        result = this.definition.task[0].label
      } else {
        result = this.language.seeTasks
      }
      return result
    }
  },
  watch: {
    object: {
      handler: function (val) {
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.groupTasks {
  .tasks > div {
    float: left;
    width: 100%;
    margin-top: 8px;
  }

  button {
    width: 100%;
  }
  &.half-task {
    .task {
      width: 50%;
      float: left;
    }
  }
  &.third-task {
    .task {
      width: 33.3333%;
      float: left;
    }
  }
  &.quarter-task {
    .task {
      width: 25%;
      float: left;
    }
  }
  .toggle_accordion {
    cursor: pointer;
    text-align: left;
    font-size: 14px;
    color: #4599a4;

    i.icon_toggle {
      color: #FFBD42;
      transition: transform .2s;
      -webkit-transform-: .2s;
      margin-left: 5px;
      font-size: 22px;
    }
    i.icon_toggle.rotate180 {
      transform: rotate(180deg);
    }
    i {
      font-size: 16px;

      &:before {
        font-weight: 900;
      }
    }
    > span {
      vertical-align: text-bottom;
      font-family: Capriola;
      font-weight: 100;
      color: #aeaeae;
    }
  }
}
.taskButton,
.taskDefinition,
.taskLink {
  .w3-buttonTask {
    background-color: transparent;
    border: 0;
    width: initial;
    font-family: Barlow;
    font-size: 14px;
    font-weight: 600;
    color: #4599a4;
    cursor: pointer;
    transition: all 0.2s ease-in;
    height: 52px;
    vertical-align: middle;
    padding: 0 10px 0 10px;
    text-align: left;
    font-weight: 100;

    &:focus {
      outline: 0;
    }

    i.sherpa-icon {
      vertical-align: middle;
      display: inline-block;
      color: #ff7643;
      transition: all 0.2s ease-in;
      font-size: 24px;
      min-width: 30px;
      line-height: 32px;
      line-height: 26px;
    }

    &:hover {
      color: #5dbecb;

      i.sherpa-icon {
        color: #ffbf28;
      }
    }
  }
  .label {
    font-family: Capriola;
    padding: 5px 0 10px 55px;

    &.ok_validate {
      color: green;
      font-style: italic;
      font-size: 13px;
      padding-left: 32px;
      font-weight: 100 !important;
    }
  }

  .spinner-loading {
    display: inline-block;
    min-width: 50px;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/task/index.vue